import { render } from "./Historico.vue?vue&type=template&id=5a1a9028&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=js"
export * from "./Historico.vue?vue&type=script&lang=js"

import "./Historico.vue?vue&type=style&index=0&id=5a1a9028&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1a9028"]])

export default __exports__